﻿(() => {
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  if (!('IntersectionObserver' in window) || reduced.matches) return;
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      if (!reduced.matches) entry.target.animate(
        [{ transform: 'translateY(18px)' }, { transform: 'translateY(0)' }],
        { duration: 600, easing: 'cubic-bezier(.2,.65,.3,1)' }
      );
      observer.unobserve(entry.target);
    });
  }, { threshold: .08 });
  const prepare = root => root.querySelectorAll('#MainContent[data-template="index"] .tt-section-heading, #MainContent[data-template="index"] .tt-product-card, #MainContent[data-template="index"] .tt-trust-card').forEach(card => observer.observe(card));
  prepare(document);
  document.addEventListener('shopify:section:load', () => prepare(document));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.tt-section-heading,.tt-product-card,.tt-trust-card').forEach(card => observer.unobserve(card));
  });
})();
